// extracted by mini-css-extract-plugin
module.exports = {"liveSales":"live-sales_liveSales__QqUk5","header":"live-sales_header__PrcxS","title":"live-sales_title__1pxsA"};